import { WORKING_LIST_ID } from '@terminal/config/constants';
import { useFilterActions } from '@terminal/hooks/use-filter-actions/useFilterActions';
import { useWorkingList } from '@terminal/hooks/use-working-list/useWorkingList';
import { SCENARIO_ASSET_FILTER_KEY } from '@terminal/widgets/scenario/hooks/use-scenario-store/filter-utils';
import { useScenarioStore } from '@terminal/widgets/scenario/hooks/use-scenario-store/useScenarioStore';
import { useTranslation } from 'react-i18next';

export const useSetScenarioWorkingList = () => {
  const { t } = useTranslation(['common']);

  const { saveWorkingList } = useWorkingList();
  const { setScenarioPageEntityTags } = useScenarioStore();
  const { addFilterOption } = useFilterActions({
    store: useScenarioStore,
    group: 'ASSET_FILTERS',
  });

  const setWorkingList = (modalTags: string[]) => {
    saveWorkingList(modalTags);
    setScenarioPageEntityTags(modalTags);
    addFilterOption({
      filterId: SCENARIO_ASSET_FILTER_KEY,
      filterKey: SCENARIO_ASSET_FILTER_KEY,
      option: {
        customHeaderTitle: undefined,
        hasBottomBorder: true,
        key: WORKING_LIST_ID,
        name: t('common:filters.workingList'),
        value: { workingList: 'working-list' },
      },
    });
  };

  return {
    setWorkingList,
  };
};
